const de = {
  common: {
    home: 'Startseite',
    email: 'Mailadresse',
    first_name: 'Vorname',
    last_name: 'Nachname',
    password: 'Passwort',
    repeat_password: 'Passwort wiederholen',
    forgot_password: 'Passwort vergessen?',
    new_password: 'Neues Passwort',
    old_password: 'Altes Passwort',
    change_password: 'Passwort ändern',
    cancel: 'Abbrechen',
    continue: 'Weiter',
    success: 'Erfolg!',
    or: 'oder',
    back: 'Zurück',
    signoff: 'Abmelden',
    edit: 'Bearbeiten',
    save: 'Speichern',
    delete_device: 'Gerät löschen',
    open_device: 'Gerät öffnen',
    page: 'Seite',
    close: 'Schließen',
    not_authorized: 'Nicht autorisiert',
    access_denied: 'Du hast keine Berechtigung, auf diese Seite zuzugreifen.',
    oops: 'Ups!',
    no_access_message: 'Anscheinend bist du nicht berechtigt, diese Ressource anzuzeigen. Bitte wende dich an den Support, wenn du glaubst, dass dies ein Fehler ist.',
    return_home: 'Zurück zur Startseite',
    next: 'Nächste',
    confirm_delete: 'Bist du dir sicher?',
    confirm_delete_message: 'Möchtest du dieses Gerät wirklich trennen?',
    delete: 'Löschen',
    loading: 'Wird geladen…',
    search: 'Suche nach Name oder Typ…',
    search_user: 'Suche nach Benutzer oder Gerät',
    elements_per_page: 'Elemente pro Seite',
    copied: 'Kopiert',
    copy_key: 'Verifizierungsschlüssel kopieren',
    reload: 'Neu laden',
    support: 'Support',
    successfully_saved: 'Änderungen erfolgreich gespeichert!',
  },
  errors: {
    
    global: 'Es ist ein Fehler aufgetreten.',
    unknown: 'Es ist ein unbekannter Fehler aufgetreten.',
    too_many_attempts: 'Zu viele Anmeldeversuche. Bitte versuche es in {seconds} Sekunden erneut.',
    could_not_authenticate: 'Benutzer konnte nicht authentifiziert werden.',
    invalid_email: 'Ungültige Mailadresse',
    no_setup_key: 'In der Antwort wurden keine Verbindungsschlüssel gefunden.',

    adminCannotDeleteOwnAccount: "Sie können Ihr eigenes Konto nicht löschen.",

    authenticationCookieRequired: "Authentifizierungs-Cookie ist erforderlich.",
    authenticationRequired: "Authentifizierung ist erforderlich.",
    authenticationRequiredForTopics: "Authentifizierung ist für diese Themen erforderlich.",

    deviceAccessDenied: "Sie haben keinen Zugriff auf dieses Gerät.",
    deviceIdRequired: "Geräte-ID ist erforderlich.",
    deviceIdRequiredInUri: "Geräte-ID ist in der URL erforderlich.",
    deviceInvalidIpAddress: "Die IP-Adresse des Geräts ist ungültig.",
    deviceIpNotInAllowedRange: "Die IP-Adresse des Geräts liegt nicht im erlaubten Bereich.",
    deviceNotFound: "Gerät nicht gefunden.",
    deviceNoIpAddress: "Dem Gerät ist keine IP-Adresse zugewiesen.",
    deviceUnavailable: "Das Gerät ist derzeit nicht verfügbar.",
    deviceUnreachable: "Das Gerät ist nicht erreichbar.",

    emailNotVerified: "Ihre E-Mail-Adresse ist nicht verifiziert.",
    email_not_verified: 'Deine E-Mail-Adresse ist nicht verifiziert.',
    emailAlreadyExists : "Ein Konto mit dieser E-Mail-Adresse existiert bereits.",

    fbSignedRequestEmpty: "Facebook Signed Request ist leer.",
    fbSignedRequestInvalidBase64: "Facebook Signed Request enthält ungültige Base64-Daten.",
    fbSignedRequestInvalidPayload: "Facebook Signed Request Payload ist ungültig.",
    fbSignedRequestMalformed: "Facebook Signed Request ist fehlerhaft.",
    fbSignedRequestSignatureMismatch: "Facebook Signed Request Signatur stimmt nicht überein.",

    fcmAccessTokenMissing: "FCM-Zugriffstoken fehlt.",
    fcmAuthFailed: "Authentifizierung mit Firebase Cloud Messaging fehlgeschlagen.",
    fcmInvalidPrivateKey: "Ungültiger Firebase Private Key.",
    fcmJwtSigningFailed: "Firebase JWT-Signierung fehlgeschlagen.",

    handledStampNotFound: "Verarbeiteter Zeitstempel nicht gefunden.",

    headerInvalidType: "Ungültiger Header-Typ.",
    headerNotAllowed: "Dieser Header ist nicht erlaubt.",
    headerValueTooLong: "Header-Wert ist zu lang.",

    httpMethodNotAllowed: "HTTP-Methode nicht erlaubt.",

    idpUnexpectedError: "Unerwarteter Fehler beim Identity Provider.",
    internalError: "Interner Serverfehler.",

    invalidCredentials: "Ungültige Zugangsdaten.",
    invalidLogLevel: "Ungültiges Log-Level.",
    invalidUserClass: "Ungültige Benutzerklasse.",

    messageHandlerNoResult: "Message-Handler hat kein Ergebnis zurückgegeben.",

    netbirdApiError: "NetBird API-Fehler.",
    netbirdClientRequestFailed: "NetBird Client-Anfrage fehlgeschlagen.",
    netbirdEmbeddedGroupNotFound: "Eingebettete NetBird-Gruppe nicht gefunden.",
    netbirdRequestFailed: "NetBird-Anfrage fehlgeschlagen.",

    oidcUserCreationFailed: "Benutzererstellung über OpenID Connect fehlgeschlagen.",

    pathEmpty: "Pfad darf nicht leer sein.",
    pathInvalidStart: "Pfand hat einen ungültigen Anfang.",
    pathTooLong: "Pfad ist zu lang.",
    pathTraversalNotAllowed: "Pfad-Traversierung ist nicht erlaubt.",

    payloadTooLarge: "Payload ist zu groß.",
    rateLimitExceeded: "Zu viele Anfragen. Bitte versuchen Sie es später erneut.",

    requestNotFoundInContext: "Anfrage im Kontext nicht gefunden.",
    requestRequired: "Anfrage ist erforderlich.",

    sessionNotFound: "Sitzung nicht gefunden.",

    ssoEmailExists: "Ein Konto mit dieser E-Mail-Adresse existiert bereits.",
    ssoMissingIdOrToken: "SSO-ID oder Token fehlt.",
    ssoMultipleUsersFound: "Mehrere Benutzer für dieses SSO-Konto gefunden.",
    ssoUserIdNotFound: "SSO-Benutzer-ID nicht gefunden.",

    storageEncodingFailed: "Speicher-Kodierung fehlgeschlagen.",
    storageRecordCorrupted: "Gespeicherter Datensatz ist beschädigt.",

    unauthorized: "Sie sind nicht berechtigt, diese Aktion auszuführen.",

    userDeleteForbidden: "Sie dürfen diesen Benutzer nicht löschen.",
    userIdParameterRequired: "Benutzer-ID-Parameter ist erforderlich.",
    userIdRequired: "Benutzer-ID ist erforderlich.",
    userNotFound: "Benutzer nicht gefunden.",

    zitadelClientRequestFailed: "Zitadel Client-Anfrage fehlgeschlagen.",
    zitadelRequestFailed: "Zitadel-Anfrage fehlgeschlagen."
  },

  verification: {
    invalid_verification_link: 'Ungültiger Bestätigungslink',
    success: 'Ihre Mailadresse wurde erfolgreich bestätigt.',
    fehlgeschlagen: 'Konnte nicht verifiziert werden {error}',
    invalid_link: 'Ungültiger Link',
    verifying_account: 'Ihr Konto wird verifiziert...',
    email_not_received: 'E-Mail nicht erhalten?',
    resend_email: 'E-Mail erneut senden',
    sending: 'E-Mail wird gesendet',
    resend_email_failed: 'Bestätigungs-E-Mail konnte nicht erneut gesendet werden.',
    resend_email_email_success: 'Bestätigungs-E-Mail erfolgreich gesendet!',
    email_not_found: 'E-Mail nicht gefunden',
    error_resending_email: 'Fehler beim erneuten Senden der E-Mail',
    email_resent: 'Die Verifizierungsmail wurde erneut gesendet. Falls du keine Mail von uns erhalten hast, bitte wende dich an den {support}.'

  },

  registration: {
    register: 'Registrieren',
    register_now: 'Jetzt registrieren',
    name: 'Name',
    repeat_password: 'Passwort wiederholen',
    already_signed_up: 'Bereits registriert?',
    sign_up: 'Registrieren',
    sign_up_subtitle: 'Erstelle ein Konto, um deine Geräte zu verwalten.',
    sign_up_here: 'Hier registrieren',
    get_started: 'Loslegen',
    no_account_yet: 'Noch kein Konto?',
    log_in_here: 'Hier einloggen',
    check_email: 'Bitte überprüfe deinen Posteingang und bestätige deine E-Mail-Adresse.',
    password_changed: 'Passwort erfolgreich geändert.',
    password_updated: 'Ihr Passwort wurde aktualisiert.',
    recheck_email: 'Du hast deine E-Mail-Adresse noch nicht verifiziert. Bitte verifiziere diese, um die App zu nutzen.',
    confirm_email: 'Bitte bestätige deine E-Mail-Adresse.',
    didnt_receive_email: 'Hast du keine E-Mail erhalten?',
    user_already_exists: 'Benutzer existiert bereits.',
    sign_up_error: 'Bei der Anmeldung ist ein Fehler aufgetreten.',
    check_credentials: 'Bitte überprüfe deine Anmeldeinformationen.',
    terms_and_conditions: 'Ich habe die {terms} und die {privacy} gelesen und stimme diesen zu.',
    terms: 'AGB',
    privacy: 'Datenschutzerklärung',


  },

  login: {
    login: 'Anmelden',
    auth: 'Authentifizierung',
    login_or_register: 'Anmelden oder Registrieren',
    sign_in: 'Einloggen',
    sign_in_subtitle: 'Melde dich an, um deine Geräte zu verwalten.',
    continue_with_email: 'Mit Mailadresse fortfahren',
    tell_us_email: 'Teile uns die E-Mail-Adresse deines Kontos mit.',
    login_google: 'Mit Google anmelden',
    login_facebook: 'Mit Facebook anmelden',
    login_apple: 'Mit Apple anmelden',
    enter_the_code: 'Gib hier den Code ein, den wir Dir gesendet haben.',
    choose_new_password: 'Wähle ein neues Passwort und fahre fort.',
    wrong_username_password: 'Du hast einen ungültigen Benutzernamen oder ein ungültiges Passwort eingegeben.',
    passwords_does_not_match: 'Die Passwörter stimmen nicht überein.',
    login_instructions: 'Wir haben Dir eine E-Mail mit Anweisungen zum Zurücksetzen Deines Passworts gesendet. Bitte überprüfe Deinen Posteingang.',
    sign_up: 'Registrieren',
    sign_in_with_email: 'Mit E-Mail anmelden',
  },

  terms: {
    terms_of_Service: 'AGB',
    privacy_policy: 'Datenschutzhinweise',
    imprint: 'Impressum',
    text: 'Indem du fortfährst, stimmst du dem folgenden zu:',
    support: 'Support',
  },

  start: {
    welcome: 'Willkommen!',
    welcome_msg: 'Verwalte deine energielenker-Geräte schnell und einfach. Behalte jederzeit und überall die Kontrolle.',
    lets_start: 'Lass uns anfangen',
  },

  menu: {
    settings: 'Einstellungen',
    plans: 'Pläne',
    home: 'Startseite',
    admin: 'Verwaltung',
  },

  home: {
    title: 'Deine Geräte',
    subtitle: 'Geräte verwalten',
    add_device: 'Gerät verbinden',
    no_devices: 'Du hast noch keine Geräte eingerichtet.',
    edit_device: 'Gerät bearbeiten',
    device_name: 'Gerätename',
    device_created: 'Enbas erfolgreich erstellt!',
    copy_key: 'Hinterlege den Schlüssel in deinen Geräteeinstellungen.',
    add_another_device: 'Füge weitere Geräte hinzu',

  },

  admin: {
    title: 'Verwaltung',
    subtitle: 'Alle Benutzer und ihre Geräte anzeigen',
  },

  settings: {
    settings: 'Einstellungen',
    profile: 'Profil',
    payment: 'Zahlung',
    notifications: 'Benachrichtigungen',
    help: 'Hilfe',
    payment_details: 'Zahlungsplan und Bankdaten',
    notification_details: 'Welche Benachrichtigungen möchtest du erhalten?',
    profile_details: 'Name und Kontaktdaten',
    help_details: 'Hilfe, Kontakt und Nutzungsbedingungen',
    subtitle: 'Name und Kontaktdaten',
  },

  plans: {
    select_plan: 'Wählen Sie Ihren Plan',
    subtitle: 'Individuell auf Ihre Bedürfnisse zugeschnitten',
    annual_pricing: 'Jährliche Preise',
    save_percentage: 'Sparen Sie {percentage} %',
    free_version: 'Kostenlose Version',
    subscribed: 'Abonniert',
    per_month: 'pro Monat',
    manage_devices: 'Verwalten Sie Ihre Geräte',
    global_access: 'Globaler Zugriff auf Geräte',
    cloud_optimization: 'Cloud+ Optimierung',
    enbas_plus: 'Enbas Plus',
    recommended: 'Empfohle',
  },

  payments: {
    title: 'Zahlungen und Abonnements',
    cancel_subscription: 'Abonnement kündigen',
    enbas_plus: 'Enbas Plus',
    active: 'Aktiv',
    inactive: 'Inaktiv',
  },

  profile: {
    name: 'Name',
    email: 'Mailadresse',
    edit_profile: 'Profil bearbeiten',
    notifications: 'Benachrichtigungen',
    delete_profile: 'Profil löschen',
    delete_profile_message: 'Möchtest du dein Konto wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.',
    type_delete_to_confirm: 'Bitte schreiben Sie "delete"!',
    delete_error: 'Beim Löschen des Profils ist ein Fehler aufgetreten. Bitte versuche es erneut.',
    language: 'Sprache',
    incorrect_old_password: 'Das eingegebene alte Passwort ist falsch.',
    password: 'Passwort',
    change_password: 'Passwort ändern',
    current_password: 'Aktuelles Passwort',
    edit_email: 'Mailadresse ändern',
    edit_name: 'Name ändern',
    edit_language: 'Sprache ändern',
    edit_password: 'Passwort ändern',
    edit_password_text: 'Gib dein aktuelles Passwort ein, um deine E-Mail-Adresse zu ändern.',
  },

  help: {
    title: 'Hilfe',
    terms_of_service: 'Allgemeine Geschäftsbedingungen',
    privacy_policy: 'Datenschutzrichtlinie',
    support: 'Support',
    imprint: 'Impressum',
    copyright: 'Copyright energielenker Solutions GmbH',
  },

  device: {
    all_devices: 'Alle Geräte',
    lobas: 'Lobas',
    enbas: 'Enbas',
    device_name: 'Gerätename',
    device_updated: 'Gerät erfolgreich aktualisiert!',
    device_name_required: 'Gerätename ist erforderlich',
    device_help_before: 'Gib den Schlüssel in den Einstellungen deines Geräts ein.',
    device_help_link: 'Hier',
    device_help_after: 'findest du weitere Informationen dazu.',
    choose_device: 'Wähle einen Namen, um fortzufahren',
    connect_device: 'Gerät verbinden',
    explanation: 'Nachdem du auf "Weiter" getippt hast, erhältst du einen Key, den du in die Administrationsoberfläche deines Geräts eingeben musst. Sobald dies erledigt ist, wird das Gerät verifiziert und du erkennst es mit dem Status "Verbunden" in der App.',
    exit_device: 'Gerät verlassen',
    view_mode: 'Derzeit im Enbas-Ansichtsmodus',
    currently_unavailable: 'Das Gerät ist derzeit nicht verfügbar (ausstehend oder getrennt).',
    first_setup_key: 'Erster Verbindungsschlüssel',
    status_changed: "Status des Geräts {deviceType} {deviceName} wurde von {previousStatus} auf {newStatus} geändert",
    verification_short_key: 'Verifizierungsschlüssel',
    explanation_key: 'Du hast den Schlüssel bereits hinterlegt? Es kann eine Weile dauern, bis die Verbindung bestätigt wurde.',
    status: {
      warning: 'Dein Gerät ist noch nicht verifiziert. Das kann einige Momente dauern.',
      update: 'Überprüfung ausstehend. Bitte stelle sicher, dass du die neueste Version auf deinem Enbas verwendest.',
      error: 'Verbindung zum Gerät fehlgeschlagen. Prüfe, ob das Gerät mit dem Internet verbunden ist.',
      info: 'Die Verbindung wurde über die Geräteeinstellungen aufgehoben.'
    },
    pending: 'Ausstehend',
    connected: 'Verbunden',
    disconnected: 'Getrennt',
    connection_lost: 'Verbindung verloren',
    connection_failed: 'Update erforderlich',
  },

  steps: {
    new_device_title: '1. Gerätname wählen',
    new_device_description: 'Füge ein neues Gerät in der App hinzu.',
    enter_key_title: '2. Key eingeben',
    enter_key_description: 'Hinterlege den Schlüssel in den Geräteeinstellungen.',
    ready_to_go_title: 'Fertig!',
    ready_to_go_description: 'Du kannst loslegen!'
  },

  install_app: {
    install: 'Installiere unsere App.',
    open_safari: 'Safari öffnen',
    tap: 'tippen',
    teilen: 'Teilen',
    add_to_home: 'Zum Startbildschirm hinzufügen',
    better_exp: 'für ein besseres Benutzererlebnis!',
    dann: 'dann',
  },

  optimize: {
    title: 'Möchten Sie die Leistung Ihres Geräts maximieren?',
    subtitle: 'Nutzen Sie das volle Potenzial von Enbas mit einem Optimierungsplan',
    learn_more: 'Mehr erfahren',
    dismiss: 'Schließen'
  },

  filter: {
    show_disconnected_devices: 'Getrennte Geräte anzeige',
    show_connected_devices: 'Verbundene Geräte anzeigen',
    filter: 'Filter',
    remove_filters: 'Alle Filter entfernen',
  },

  notifications: {
    deviceStatusChanged: "Gerät {deviceId} wurde von {from} zu {to} geändert",
    status: {
      pending_connected: "Dein {deviceType} {deviceName} hat sich erfolgreich verbunden.",
      connected_disconnected: "Dein {deviceType} {deviceName} wurde getrennt.",
      disconnected_connected: "Dein {deviceType} {deviceName} ist wieder verbunden.",
      connected_connection_lost: "Dein {deviceType} {deviceName} hat die Verbindung verloren.",
      connection_lost_connected: "Dein {deviceType} {deviceName} hat sich erfolgreich wieder verbunden.",
      update_required_connected: "Dein {deviceType} {deviceName} wurde aktualisiert und ist wieder verbunden.",
      update_required_disconnected: "Dein {deviceType} {deviceName} wurde getrennt und benötigt noch ein Update.",
      connection_lost_disconnected: "Dein {deviceType} {deviceName} ist nicht mehr erreichbar und wurde getrennt.",
      pending: "Dein {deviceType} {deviceName} wartet auf Verbindung.",
      update_required: "Dein {deviceType} {deviceName} benötigt ein Update.",
      fallback: "Statusupdate für {deviceType} {deviceName}"
    }
  },

  password: {
    submission_errors: 'Bei Ihrer Übermittlung sind {errorsNum} Fehler aufgetreten',
    password_valid: 'Ihr Übermittlung erfüllt alle Anforderungen.',
    password_errors: {
      length: 'Ihr Passwort muss mindestens 8 Zeichen lang sein',
      uppercase: 'Mindestens 1 Großbuchstabe',
      lowercase: 'Mindestens 1 Kleinbuchstabe',
      number: 'Mindestens 1 Zahl',
      specialChar: 'Mindestens 1 Sonderzeichen',
      mismatch: 'Passwörter stimmen nicht überein',
      max_length: 'Passwort ist zu lang',
    }
  },


  form: {
    no_errors_in_form: 'Ihr Formular erfüllt alle Anforderungen.',
    submission_errors: 'Bei Ihrer Übermittlung sind {errorsNum} Fehler aufgetreten.',
    errors: {
      invalid_email: 'Ungültige Mailadresse',
      first_name_short: 'Vorname ist zu kurz',
      last_name_short: 'Nachname ist zu kurz',
      first_name_too_long: 'Vorname ist zu lang',
      last_name_too_long: '',
      email_too_long: 'Mailadresse ist zu lang',
      email_required: 'Mailadresse fehlt',
    }
  },

  page_titles: {
    welcome: 'Willkommen',
    signup_login: 'Einloggen oder Registrieren',
    sign_up: 'Registrieren',
    sign_in: 'Einloggen',
    signup_success: 'Registrierung Erfolgreich',
    forgot_password: 'Passwort vergessen',
    reset_password: 'Passwort zurücksetzen',
    user_verify: 'Benutzer verifizieren',
    edit_password: 'Passwort ändern',
    edit_name: 'Name ändern',
    edit_email: 'Mailadresse ändern',

    plans: 'Pläne',
    profile: 'Profil',
    edit_profile: 'Profil bearbeiten',
    notifications: 'Meldungen',
    help: 'Hilfe',
    payments: 'Zahlungsmethoden',
    settings: 'Einstellungen',
    home: 'Geräte',
    edit_device: 'Gerät bearbeiten',
    not_authorized: 'Nicht autorisiert',
    sso_success: 'SSO-Anmeldung erfolgreich',
    sso_fail: 'SSO-Anmeldung fehlgeschlagen',
    admin: 'Verwaltung',
  },
  offline: {
    headline: 'Wir sind gleich wieder da!',
    message: 'Unser System wird gerade gewartet, damit du bald ein noch besseres Erlebnis hast. Bitte schau später wieder vorbei.',
  },
};

export default de;